export const organizationUsersQueryKey = (organizationId: string) =>
  ['organization-users', organizationId] as const

export const organizationRolesQueryKey = (organizationId: string) =>
  ['organization-roles', organizationId] as const

export const organizationAuditLogsQueryKey = (organizationId: string) =>
  ['audit-logs', organizationId] as const
